.a8{width:100%;}